import './child-bio-details.scss';

import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';

import { ChildDetails } from '@sola/schema/dotcom/children/child.js';

export const ChildBioDetailsHeading = ({
  hangul,
  name,
  seoLevel = 1,
}: Pick<ChildDetails, 'name' | 'hangul'> & { seoLevel?: number }) => {
  const { t } = useTranslation(['bio']);

  const Comp = `h${seoLevel}` as ElementType;
  return (
    <Comp className="ChildBioDetails__heading heading-potent heading-xl mb-comfy-sm">
      {t('bio:title', {
        childName: name.preferred,
        koreanName: hangul.preferred || name.preferred,
      })}
    </Comp>
  );
};
